<template>
	<app-title-bar :icon="['fas', 'fa-rocket']" subtitle="Dashboard" title="CAT2" />

	<app-panel title="Welcome to the CAT2 Dashboard">
		<p>
			Find your way around using the sidebar on the left. If you're on a mobile device, click
			the bars in the top left. Manage your account using the menu in the top right.
		</p>
	</app-panel>
</template>

<script lang="ts" setup></script>
